import * as React from "react";
import { History } from "lucide-react";
import { FULL_HISTORY_GBP } from "../lib/pricing";

export const MONTHLY_HISTORY_HEADING = "Monthly Pro keeps the 12-month window";
export const MONTHLY_HISTORY_BODY = `Pro monthly does not include Full history, so Atlas keeps matching your last 12 months only. Yearly Pro includes Full history for good, or unlock Full history first for £${FULL_HISTORY_GBP} once.`;
export const MONTHLY_HISTORY_CONFIRM =
  "Monthly Pro does not include Full history. Atlas will keep matching your last 12 months only. Continue with monthly?";

/** Plain confirm before a monthly checkout for someone without Full history. */
export function confirmMonthlyWithoutHistory(): boolean {
  return window.confirm(MONTHLY_HISTORY_CONFIRM);
}

const quietButton: React.CSSProperties = {
  background: "transparent",
  border: "1px solid var(--border-subtle)",
  borderRadius: "var(--radius-pill)",
  color: "var(--text-primary)",
  fontFamily: "var(--font-sans)",
  fontSize: 13,
  fontWeight: 600,
  padding: "6px 12px",
  cursor: "pointer",
};

/** Shown where someone picks monthly Pro without Full history. */
export function MonthlyHistoryNotice({
  onChooseYearly,
  onUnlockFullHistory,
  unlockText,
  compact,
}: {
  onChooseYearly?: () => void;
  onUnlockFullHistory?: () => void;
  /** Replaces the unlock button (and the price sentence) where there is no Full history checkout. */
  unlockText?: string;
  compact?: boolean;
}) {
  const body = unlockText
    ? "Pro monthly does not include Full history, so Atlas keeps matching your last 12 months only. Yearly Pro includes Full history for good."
    : MONTHLY_HISTORY_BODY;
  return (
    <div
      role="note"
      style={{
        display: "flex",
        gap: 10,
        alignItems: "flex-start",
        padding: compact ? "10px 12px" : "12px 14px",
        background: "var(--danger-soft)",
        border: "1px solid var(--status-danger)",
        borderRadius: "var(--radius-md)",
        textAlign: "left",
      }}
    >
      <History size={18} style={{ color: "var(--status-danger)", flexShrink: 0, marginTop: 1 }} aria-hidden />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)", marginBottom: 4 }}>
          {MONTHLY_HISTORY_HEADING}
        </div>
        <div style={{ fontSize: 13, lineHeight: 1.5, color: "var(--text-secondary)" }}>{body}</div>
        {unlockText && (
          <div style={{ fontSize: 13, lineHeight: 1.5, color: "var(--text-secondary)", marginTop: 4 }}>{unlockText}</div>
        )}
        {(onChooseYearly || (onUnlockFullHistory && !unlockText)) && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10 }}>
            {onChooseYearly && (
              <button type="button" style={quietButton} onClick={onChooseYearly}>
                Choose yearly instead
              </button>
            )}
            {onUnlockFullHistory && !unlockText && (
              <button type="button" style={quietButton} onClick={onUnlockFullHistory}>
                Unlock Full history first
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
